<script setup lang="ts">
const cards = [
  {
    title: 'Innovate',
    image: '/v2/mission-card-1.png',
    text: 'Unique services are provided for the ultimate Web3 experience, enabling end-users to save time and manage assets more efficiently.',
  },
  {
    title: 'Build',
    image: '/v2/mission-card-2.png',
    text: 'With deep Web3 expertise ranging from wallets to aggregators, the focus is now on building scalable blockchain solutions in the RWA space.',
  },
  {
    title: 'Contribute',
    image: '/v2/mission-card-3.png',
    text: 'SwitchCase believes Real World Assets are the next evolution of Web3, our mission is to make tokenization tools accessible, transparent, and easy to use for everyone.',
  },
];
</script>

<template>
  <section id="mission" class="mission-wrapper">
    <div class="mission">
      <h2 class="title headline-2">Mission</h2>
      <div class="cards-wrapper">
        <div v-for="(card, index) in cards" class="card" :key="index">
          <div class="image-wrapper">
            <nuxt-img :src="card.image" class="card__image" alt="" />
            <nuxt-img
              :src="card.image.replace('.png', '-hover.png')"
              class="card__image--hover"
              :class="`card-image-hover-${index}`"
              alt=""
            />
          </div>
          <h3 class="card-title font-subtitle">{{ card.title }}</h3>
          <p class="card-text font-bodytext">
            {{ card.text }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.mission-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.mission {
  width: 100%;
  max-width: 1440px;
  padding: 120px 40px 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 60px;
}

.title {
  text-transform: uppercase;
}

.cards-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 40px;
}

.card {
  width: 100%;
  max-width: 427px;
  height: 325px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.image-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 16px;
}

.card__image {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.card__image--hover {
  position: absolute;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.card-image-hover-1 {
  max-height: 83%;
}
.card-image-hover-2 {
  max-height: 83%;
}

.card-title {
  color: var(--main-blue);
  margin-bottom: 12px;
  text-transform: uppercase;
}

.card:hover .card__image--hover {
  opacity: 1;
}

@media (max-width: 1200px) {
  .mission {
    padding: 120px 20px 60px;
  }

  .cards-wrapper {
    align-items: flex-start;
  }

  .card {
    height: auto;
  }

  .image-wrapper {
    margin-bottom: 12px;
  }

  .card-title {
    margin-bottom: 8px;
  }
}

@media (max-width: 1023px) {
  .mission {
    gap: 32px;
    padding: 60px 20px 30px;
  }

  .cards-wrapper {
    gap: 20px;
  }
}

@media (max-width: 743px) {
  .mission {
    padding: 30px 20px 30px;
  }

  .cards-wrapper {
    width: 100%;
    flex-direction: column;
  }

  .card {
    height: auto;
  }
}
</style>
